import React, { useContext, useEffect, useState } from 'react';
import { Modal, message, Form, Input, Select } from 'antd';
import { Context } from '../../../defaults';
import { updateGroup } from '../../../actions';

export function GroupsModal({ modalProps, closeModal }) {
    const { dictionary, language, setLoading } = useContext(Context);
    const [currentGroup, setCurrentGroup] = useState({});
    const modalTitle = `${dictionary?.Group[language]}`;
    const requiredMessage = `${dictionary?.RequiredField[language]}`;

    useEffect(() => {
        if (modalProps.currentGroup) {
            setCurrentGroup(modalProps.currentGroup);
        }
    }, [modalProps.currentGroup]);

    const onUpdateGroup = () => {
        updateGroup(currentGroup)
            .then(() => {
                message.success(dictionary?.SuccessfullyChanged[language], { duration: 4 });
                closeModal(true);
            })
            .catch(() => {
                message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
                closeModal();
            });
    };

    const onChange = ({ target }) => {
        const { name, value } = target;
        setCurrentGroup({ ...currentGroup, [name]: value });
    }


    return (
        <Modal
            title={modalTitle}
            visible={modalProps.visible}
            onOk={onUpdateGroup}
            okButtonProps={{ disabled: !currentGroup?.name }}
            onCancel={() => closeModal()}
            okText={dictionary?.Save[language]}
            cancelText={dictionary?.Cancel[language]} >
            <Form
                layout='horizontal'
                labelCol={{ span: 7 }}
                name='nest-messages'
            >
                <Form.Item
                    label={dictionary?.Name[language]}
                    validateStatus={currentGroup?.name ? 'success' : 'error'}
                    help={currentGroup?.name ? '' : requiredMessage}
                    hasFeedback
                >
                    <Input
                        style={{ width: '100%' }}
                        name='name'
                        onChange={onChange}
                        value={currentGroup?.name}
                    />
                </Form.Item>
            </Form>
        </Modal >
    );
}
